import { render, staticRenderFns } from "./mostEye.vue?vue&type=template&id=236c3594&scoped=true&"
import script from "./mostEye.vue?vue&type=script&lang=js&"
export * from "./mostEye.vue?vue&type=script&lang=js&"
import style0 from "./mostEye.vue?vue&type=style&index=0&id=236c3594&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c3594",
  null
  
)

export default component.exports